import React from "react";

const SocialShare = [
  //AGG START
  {
    iconName: "instagram",
    link: "https://www.instagram.com/asiergonzalez.es/",
  },
  { iconName: "twitter", link: "https://x.com/AsierGlez" },
  //{ iconName: "bsky", link: "https://bsky.app/profile/asiergonzalez.es" },
  {
    iconName: "linkedin",
    link: "https://www.linkedin.com/in/asiergonzalez/en",
  },
  {
    iconName: "youtube",
    link: "https://www.youtube.com/@asierglez",
  },
  {
    iconName: "spotify",
    link: "https://open.spotify.com/show/3btLqh2WmXh7mZUTRYFN0z",
  }
];
// AGG END
const Social = () => {
  return (
    <>
      <ul className="social">
        {SocialShare.map((val, i) => (
          <li key={i}>
            <a href={`${val.link}`} target="_blank" rel="noreferrer">
              <img
                className="svg"
                src={`/assets/img/svg/social/${val.iconName}.svg`}
                alt="social"
              ></img>
            </a>
          </li>
        ))}
      </ul>
      {/* END SOCIAL */}
    </>
  );
};

export default Social;
